import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CustomCart } from '@cart/const';
import { CartTotalsOrderComponent } from '../cart-totals-order';

@Component({
  selector: 'sd-cart-totals-floating',
  imports: [CartTotalsOrderComponent],
  templateUrl: './cart-totals-floating.component.html',
  styleUrls: ['./cart-totals-floating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsFloatingComponent {
  readonly cart = input.required<CustomCart>();
}
